var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import client from "@irati/utils/services/apollo";
import authentication from "@irati/auth";
import getAllOccasions from "./queries/GetAllOccasions";
import createOccasion from "./mutations/CreateOccasion";
import updateOccasion from "./mutations/UpdateOccasion";
var OccasionsService = /** @class */ (function () {
    function OccasionsService() {
    }
    OccasionsService.prototype.getAll = function () {
        var variables = {
            tenantId: authentication.userTenant().uuid
        };
        return client.query({ query: getAllOccasions, variables: variables, fetchPolicy: "network-only" }).then(function (res) { return res.data.occasions.results; });
    };
    OccasionsService.prototype.create = function (occasion) {
        var variables = {
            occasion: occasion,
            tenantId: authentication.userTenant().uuid
        };
        return client.mutate({ mutation: createOccasion, variables: variables }).then(function (res) {
            return res.data.createReward;
        });
    };
    OccasionsService.prototype.hide = function (occasion) {
        var variables = {
            occasion: cleanOccasion(occasion),
            occasionId: occasion.uuid,
            tenantId: authentication.userTenant().uuid
        };
        variables.occasion.archived = true;
        variables.occasion.createdAt = undefined;
        return client.mutate({ mutation: updateOccasion, variables: variables });
    };
    OccasionsService.prototype.show = function (occasion) {
        var variables = {
            occasion: cleanOccasion(occasion),
            occasionId: occasion.uuid,
            tenantId: authentication.userTenant().uuid
        };
        variables.occasion.archived = false;
        variables.occasion.createdAt = undefined;
        return client.mutate({ mutation: updateOccasion, variables: variables });
    };
    OccasionsService.prototype.update = function (occasion, occasionId) {
        var variables = {
            occasion: cleanOccasion(occasion),
            occasionId: occasionId,
            tenantId: authentication.userTenant().uuid
        };
        return client.mutate({ mutation: updateOccasion, variables: variables });
    };
    return OccasionsService;
}());
function cleanOccasion(occasionBase) {
    var occasion = __assign({}, occasionBase);
    occasion.uuid = undefined;
    occasion.default = undefined;
    occasion.createdAt = undefined;
    return occasionBase;
}
export default new OccasionsService();
